import React, { createRef, useContext, useEffect } from "react";
import Scrollbar from "./Scrollbar";
import { makeStyles } from '@mui/styles';
import { Typing, OptionsList, Text } from "../Message";
import { ConversationContext } from "../index";
import RatingList from "../Message/RatingList";

const useStyles = makeStyles(theme => ({
  conversation: {
    flex: "0 0 auto",
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(0, 2)
  }
}));

function Messages({ conversation }) {
  const chatWindowRef = createRef();
  const { setInputPlaceholderOption } = useContext(ConversationContext);

  useEffect(() => {
    chatWindowRef.current.scrollToBottom();
  }, [conversation]);

  const classes = useStyles();
  return (
    <Scrollbar ref={chatWindowRef}>
      <div className={classes.conversation}>
        {conversation.map((message, index) => {
          switch (message.type) {
            case "typing":
              return <Typing key={index} />;
            case "options":
              setInputPlaceholderOption();
              return (
                <OptionsList
                  chatWindowRef={chatWindowRef}
                  key={index}
                  options={message.options}
                />
              );
            case "rating":
              return <RatingList key={index} initialValue={message.value} />;
            case "text":
            case "postback":
            default:
              return (
                <Text key={index} sender={message.sender}>
                  {message.text}
                </Text>
              );
          }
        })}
      </div>
    </Scrollbar>
  );
}

export default Messages;
